<template>
  <button
    type="button"
    class="residency-lk-sidebar__logout"
    aria-label="Выйти из профиля"
    @click="open"
  >
    <svg class="lk-icon" width="24" height="24" aria-hidden="true" focusable="false">
      <use :href="`${ICONS_BASE}/residency-lk-sprite.svg#lk-icon-logout`" />
    </svg>
    <span class="residency-lk-sidebar__logout-text">Выйти</span>
  </button>

  <a-modal
    v-model:open="isOpen"
    centered
    :width="400"
    class="logout-confirm-lk-modal"
    :footer="null"
    :closable="false"
    :mask-closable="true"
    :keyboard="true"
    @cancel="close"
  >
    <h3 class="logout-confirm-lk-modal__title">{{ props.title }}</h3>
    <div class="logout-confirm-lk-modal__divider" aria-hidden="true" />

    <div class="logout-confirm-lk-modal__actions">
      <button type="button" class="btn btn-secondary btn-medium" @click="close">
        {{ props.cancelLabel }}
      </button>
      <button
        type="button"
        class="btn btn-primary btn-medium"
        data-barba-prevent
        @click="confirmLogout"
      >
        {{ props.confirmLabel }}
      </button>
    </div>
  </a-modal>
</template>

<script setup lang="ts">
import { computed, nextTick, ref } from 'vue';

const ICONS_BASE =
  process.env.NODE_ENV === 'development'
    ? '/assets/images/icons'
    : '/local/templates/dist/assets/images/icons';

const props = withDefaults(
  defineProps<{
    logoutUrl?: string;
    title?: string;
    cancelLabel?: string;
    confirmLabel?: string;
  }>(),
  {
    logoutUrl: 'login-form.html',
    title: 'Выйти из профиля?',
    cancelLabel: 'Остаться',
    confirmLabel: 'Да, выйти',
  },
);

const isOpen = ref(false);
const normalizedLogoutUrl = computed(() => props.logoutUrl.trim());

const open = async () => {
  isOpen.value = true;
  await nextTick();
  // ЛК шире экрана — модалка центрируется по странице; подскролливаем к ней
  requestAnimationFrame(() => {
    document.querySelector('.logout-confirm-lk-modal')?.scrollIntoView({
      block: 'center',
      inline: 'center',
    });
  });
};

const close = () => {
  isOpen.value = false;
};

const confirmLogout = () => {
  window.location.href = normalizedLogoutUrl.value;
};
</script>

<style>
.logout-confirm-lk-modal .ant-modal-content {
  padding: 32px 32px 28px;
  border-radius: 12px;
}

.logout-confirm-lk-modal .ant-modal-body {
  display: flex;
  flex-direction: column;
}

.logout-confirm-lk-modal__title {
  font-family: var(--stc-font-semibold), sans-serif;
  font-size: 20px;
  line-height: 160%;
  letter-spacing: 0%;
  color: var(--stc-black);
}

.logout-confirm-lk-modal__divider {
  margin-top: 24px;
  width: 100%;
  height: 1px;
  background: var(--stc-black-100);
}

.logout-confirm-lk-modal__actions {
  margin-top: 22px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
</style>
